"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformResource = void 0;
/**
 * Super-admin surface (TZ §6). Every route here requires a platform-level
 * permission, so a tenant user calling them gets 403.
 */
class PlatformResource {
    http;
    constructor(http) {
        this.http = http;
    }
    stats() {
        return this.http.get('platform/stats');
    }
    listTenants(query) {
        return this.http.getPaginated('platform/tenants', { query });
    }
    getTenant(id) {
        return this.http.get(`platform/tenants/${id}`);
    }
    /** Creates the company together with its first owner account. */
    createTenant(payload) {
        return this.http.post('platform/tenants', payload);
    }
    updateTenant(id, payload) {
        return this.http.patch(`platform/tenants/${id}`, payload);
    }
    blockTenant(id, reason) {
        return this.http.post(`platform/tenants/${id}/block`, { reason });
    }
    activateTenant(id) {
        return this.http.post(`platform/tenants/${id}/activate`);
    }
    listPlans() {
        return this.http.get('platform/plans');
    }
    createPlan(payload) {
        return this.http.post('platform/plans', payload);
    }
    assignSubscription(tenantId, payload) {
        return this.http.post(`platform/tenants/${tenantId}/subscription`, payload);
    }
    /** Current usage against the plan's limits, for the limits screen. */
    subscriptionUsage(tenantId) {
        return this.http.get(`platform/tenants/${tenantId}/usage`);
    }
    /*
     * Integrations the platform wires up for a restaurant (TZ §6, §15). The
     * restaurant's own admin cannot set these — a bot token or a payment key
     * swapped by a tenant would redirect its orders or its money.
     */
    /** Attaches the restaurant's bot. The token is verified, then encrypted. */
    saveTenantTelegram(tenantId, payload) {
        return this.http.put(`platform/tenants/${tenantId}/telegram`, payload);
    }
    /** Whether a payment key is on file — the key itself is never returned. */
    tenantPaymentProvider(tenantId) {
        return this.http.get(`platform/tenants/${tenantId}/payment-provider`);
    }
    saveTenantPaymentProvider(tenantId, payload) {
        return this.http.put(`platform/tenants/${tenantId}/payment-provider`, payload);
    }
}
exports.PlatformResource = PlatformResource;
//# sourceMappingURL=platform.js.map